export const formatTimestampForDisplay = (time: string | null | undefined, fallback: string = '-'): string => {
    if (!time) return fallback
    const d = new Date(time)
    if (Number.isNaN(d.getTime())) return fallback
    const date = d.toLocaleDateString('nb-NO', { day: '2-digit', month: '2-digit', year: 'numeric' })
    const timeStr = d.toLocaleTimeString('nb-NO', { hour: '2-digit', minute: '2-digit' })
    return `${date} - ${timeStr}`
}

export const formatMeasurementValueWithMaxTwoDecimals = (value: unknown): string => {
    if (typeof value === 'number' && Number.isFinite(value)) {
        return Number(value.toFixed(2)).toString()
    }

    return String(value)
}
